module.exports = __webpack_public_path__ + "static/img/index1_1.9b74045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/index1_1.jpg
// module id = z/8n
// module chunks = 1